import axios from "axios";

const BASE_URL = import.meta.env.VITE_BASE_URL;
const DEVELOPMENT_URL = import.meta.env.VITE_DEVELOPMENT_URL;
const PREVIEW_URL = import.meta.env.VITE_PREVIEW_URL;
const POST_FILE_URL = import.meta.env.VITE_POST_FILE_URL;

export const CustomElementsService = {
  GET_CUSTOM_ELEMENTS(data) {
    return axios({
      method: "get",
      url:
        DEVELOPMENT_URL +
        `custom-elements?type=${data.type}&filter=${data.filter}&userId=${data.userID}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  POST_CUSTOM_ELEMENT(data) {
    return axios({
      method: "post",
      url: DEVELOPMENT_URL + "custom-elements",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data,
    });
  },

  UPDATE_CUSTOM_ELEMENT(customElementID,data) {
    return axios({
      method: "put",
      url: DEVELOPMENT_URL + `custom-elements/${customElementID}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "*/*" 
      },
      data,
    });
  },
  DELETE_CUSTOM_ELEMENT(customElementID) {
    return axios({
      method: "delete",
      url: DEVELOPMENT_URL + `custom-elements/${customElementID}`,
    });
  },
};


